module.exports = __webpack_public_path__ + "static/media/report-icon.acb7bd57.svg";